import { render, staticRenderFns } from "./ContractRequestManagement.vue?vue&type=template&id=83719a04&"
import script from "./ContractRequestManagement.vue?vue&type=script&lang=js&"
export * from "./ContractRequestManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports